import { render, staticRenderFns } from "./FakeLoading.vue?vue&type=template&id=16b83b32&scoped=true"
import script from "./FakeLoading.vue?vue&type=script&lang=js"
export * from "./FakeLoading.vue?vue&type=script&lang=js"
import style0 from "./FakeLoading.vue?vue&type=style&index=0&id=16b83b32&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b83b32",
  null
  
)

export default component.exports